module.exports = __webpack_public_path__ + "static/media/mobileScreenshot06.78fcdc8f.jpg";